import './style/ResetPassword.css';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import PublicNav from '../components/PublicNav';
import { supabase } from '../supabaseClient';

const ResetPassword = () => {
    const [password, setPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [passwordError, setPasswordError] = useState('');
    const [confirmError, setConfirmError] = useState('');
    const [passwordTouched, setPasswordTouched] = useState(false);
    const [confirmTouched, setConfirmTouched] = useState(false);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);
    const navigate = useNavigate();

    const validatePassword = (value, touched = false) => {
        if (value.length === 0) return touched ? 'Required' : '';
        if (value.length < 8) return 'At least 8 characters';
        if (!/[A-Z]/.test(value)) return 'Include an uppercase letter';
        if (!/[a-z]/.test(value)) return 'Include a lowercase letter';
        if (!/[0-9]/.test(value)) return 'Include a number';
        if (!/[^A-Za-z0-9]/.test(value)) return 'Include a special character';
        return '';
    };

    const handlePasswordChange = (e) => {
        const val = e.target.value;
        setPassword(val);
        if (passwordTouched) setPasswordError(validatePassword(val, true));
        if (confirmTouched && confirmPassword) {
            setConfirmError(val !== confirmPassword ? 'Passwords do not match' : '');
        }
    };

    const handleConfirmChange = (e) => {
        const val = e.target.value;
        setConfirmPassword(val);
        if (confirmTouched) setConfirmError(val !== password ? 'Passwords do not match' : val.length === 0 ? 'Required' : '');
    };

    const handlePasswordBlur = () => {
        setPasswordTouched(true);
        setPasswordError(validatePassword(password, true));
    };

    const handleConfirmBlur = () => {
        setConfirmTouched(true);
        setConfirmError(confirmPassword.length === 0 ? 'Required' : confirmPassword !== password ? 'Passwords do not match' : '');
    };

    const onSubmit = async (e) => {
        e.preventDefault();
        setPasswordTouched(true);
        setConfirmTouched(true);
        const pwErr = validatePassword(password, true);
        const cfErr = confirmPassword.length === 0 ? 'Required' : confirmPassword !== password ? 'Passwords do not match' : '';
        setPasswordError(pwErr);
        setConfirmError(cfErr);
        if (pwErr || cfErr) return;
        setLoading(true);
        setError('');
        try {
            const { error: updateError } = await supabase.auth.updateUser({ password });
            if (updateError) {
                setError(updateError.message);
                return;
            }
            setSuccess(true);
            await supabase.auth.signOut();
            setTimeout(() => navigate('/login'), 2000);
        } 
        catch (err) {
            console.error(err);
            setError('Something went wrong. Please try again.');
        } 
        finally {
            setLoading(false);
        }
    };

    return (
        <div className='reset-password-container'>
            <PublicNav />
            <form onSubmit={onSubmit}>
                <div className='panel-header'>
                    <h3>{success ? 'Password Updated' : 'Reset Password'}</h3>
                    <p>{success ? 'Redirecting to login...' : 'Enter your new password'}</p>
                </div>
                {!success && (
                    <>
                        <div className='credentials-section'>
                            <div className={`input-group${passwordError && passwordTouched ? ' input-error' : ''}`}>
                                <input className='password-input' type='password' name='password' id='reset-password' value={password} onChange={handlePasswordChange} onBlur={handlePasswordBlur} placeholder=' '/>
                                <label htmlFor='reset-password'>New Password</label>
                                {passwordError && passwordTouched && <span className='field-error'>{passwordError}</span>}
                            </div>
                            <div className={`input-group${confirmError && confirmTouched ? ' input-error' : ''}`}>
                                <input className='confirm-input' type='password' name='confirmPassword' id='reset-confirm' value={confirmPassword} onChange={handleConfirmChange} onBlur={handleConfirmBlur} placeholder=' '/>
                                <label htmlFor='reset-confirm'>Confirm Password</label>
                                {confirmError && confirmTouched && <span className='field-error'>{confirmError}</span>}
                            </div>
                            {error && <div className='error'>{error}</div>}
                        </div>
                        <div className='actions-section'>
                            <button type="submit" disabled={loading}>
                                {loading ? <div className='reset-spinner' /> : 'Update Password'}
                            </button>
                        </div>
                    </>
                )}
            </form>
        </div>
    );
};

export default ResetPassword;
